module.exports = __webpack_public_path__ + "img/kompack-logo.34e8b273.svg";